import { OptionalTimeZone } from '../../timezones'
import {
  ExtendedTemplateItemOptions,
  FilenameTemplateItem,
} from './FilenameTemplateItem'

type Inspection<T> = T & { reportDate?: Date; createdDate?: Date }

type DailyInspectionInspection = Inspection<{ inspectionId?: string }>
export class InspectionFilenameTemplateItem<
  Property extends keyof DailyInspectionInspection,
  ID extends string
> extends FilenameTemplateItem<
  DailyInspectionInspection,
  'DailyInspectionInspection',
  Property,
  ID
> {
  value<T extends DailyInspectionInspection>(
    record: T | undefined,
    tz: OptionalTimeZone
  ): string {
    if (this.property === 'inspectionId')
      return this.resolve(record?.['inspectionId'])
    return this.resolveDate(
      record?.['reportDate'] ?? record?.['createdDate'],
      tz
    )
  }
  /**
   * @see {@link FilenameTemplateItem}
   */
  constructor(
    options: ExtendedTemplateItemOptions<
      DailyInspectionInspection,
      Property,
      ID
    >
  ) {
    super({ classType: 'DailyInspectionInspection', ...options })
  }
}

type DailyInspectionControlPoint = Inspection<{
  controlPointId?: string
}>
export class ControlPointFilenameTemplateItem<
  Property extends keyof DailyInspectionControlPoint,
  ID extends string
> extends FilenameTemplateItem<
  DailyInspectionControlPoint,
  'DailyInspectionControlPoint',
  Property,
  ID
> {
  value<T extends DailyInspectionControlPoint>(
    record: T | undefined,
    tz: OptionalTimeZone
  ): string {
    if (this.property === 'controlPointId')
      return this.resolve(record?.['controlPointId'])
    return this.resolveDate(
      record?.['reportDate'] ?? record?.['createdDate'],
      tz
    )
  }
  /**
   * @see {@link FilenameTemplateItem}
   */
  constructor(
    options: ExtendedTemplateItemOptions<
      DailyInspectionControlPoint,
      Property,
      ID
    >
  ) {
    super({ classType: 'DailyInspectionControlPoint', ...options })
  }
}

type DailyInspectionPunchList = Inspection<{ punchListId?: string }>
export class PunchListFilenameTemplateItem<
  Property extends keyof DailyInspectionPunchList,
  ID extends string
> extends FilenameTemplateItem<
  DailyInspectionPunchList,
  'DailyInspectionPunchList',
  Property,
  ID
> {
  value<T extends DailyInspectionPunchList>(
    record: T | undefined,
    tz: OptionalTimeZone
  ): string {
    if (this.property === 'punchListId')
      return this.resolve(record?.['punchListId'])
    return this.resolveDate(
      record?.['reportDate'] ?? record?.['createdDate'],
      tz
    )
  }
  /**
   * @see {@link FilenameTemplateItem}
   */
  constructor(
    options: ExtendedTemplateItemOptions<DailyInspectionPunchList, Property, ID>
  ) {
    super({ classType: 'DailyInspectionPunchList', ...options })
  }
}

type DailyInspectionWorkType = { name?: string; shortName?: string }
export class WorkTypeFilenameTemplateItem<
  Property extends keyof DailyInspectionWorkType,
  ID extends string
> extends FilenameTemplateItem<
  DailyInspectionWorkType,
  'DailyInspectionWorkType',
  Property,
  ID
> {
  /**
   * @see {@link FilenameTemplateItem}
   */
  constructor(
    options: ExtendedTemplateItemOptions<DailyInspectionWorkType, Property, ID>
  ) {
    super({ classType: 'DailyInspectionWorkType', ...options })
  }
}
